<template>
	<div
		:class="['container__tag', className]"
		@click="$emit('click', label)"
	>
		{{ label }}
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Classe que sera aplicada
		 */
		className: String,
		/**
		 * Legenda para a Tag
		 */
		label: String,
	},
}
</script>

<style scoped src="../../css/tag.css"></style>
